import { gql } from '@apollo/client';

export const NEW_MATERIAL = gql`
  fragment NewMaterial on Material {
    id
  }
`;
